package org.ecolution.webpage.data

data class ImageItem(val sourcePath: String, val captionText: String)
